'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffRequestLineItem', function (TimeService) {
      return {
        templateUrl: 'views/directives/saDaysOffRequestLineItem.html',
        restrict: 'A',
        scope: {
          request: '=',
          user: '=',
          me: '=loggedInUser'
        },
        link: function(scope) {
          if (_.isUndefined(scope.user)) {
            scope.userObject = scope.request.user;
          } else {
            scope.userObject = scope.user;
          }

          scope.dayoffMif = TimeService.minimalIntervalTimeFormat(scope.request.range_twix);

        },
        controller: ['$scope', '$state', function($scope, $state) {
          $scope.goToPage = function() {
            $state.go('profile.daysOff.show', {userId: $scope.me.id, dayOffId: $scope.request.id});
          };
        }]
      };
    });
